import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";

export const KeepRecord = (props) => {
  const data = {
    title: "Do you usually keep a record of what you eat?",
    list: [{
      content: "Every meal",
    },{
      content: "I do when I remember",
    },{
      content: "Not at all",
    }]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect list={data} {...props} />
    </div>
  );
};
